import React, { Component } from 'react';
import { Row, Table } from 'antd';
import moment from 'moment';
import { connect } from 'react-redux';

import { queryApplyContractList } from '@api/xxcrm/contract';
import { BackBtn } from '@comm/BackBtn';

import ModalAllot from './ModalAllot2';
import SearchForm from './Treeselect';

// import SearchForm from './FormApplySearch'

class Index extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: [],
      applyModalVisible: false,
      pageNo: 1,
      permission: {},
      total: 0,
    };
  }

  componentWillMount() {
    this.date = '';
    this.orgUuid = '';
    this.userUuid = '';
    this.type = '';
    this.status = '';
  }

  componentDidMount() {
    this.loadDate(1, 15);

    this.judge(this.props.account_info);
  }

  /**
   * 依据角色判断权限
   */
  judge = accountInfo => {
    const permission = {};
    const role = accountInfo.roles;
    role.map(sign => {
      if (sign === '[FinanceMenber]' || sign === '[XZManager]') {
        permission.allot = true;
      }
      return permission;
    });
    if (accountInfo.admin) {
      permission.allot = true;
    }
    this.setState({
      permission,
    });
  };

  loadDate = (pageNo, pageSize, date, orgUuid, userUuid, type, status) => {
    const params = {};
    const context = this;
    params.limit = 15;
    const no = this.state.pageNo;
    const current = pageNo || no;
    params.start = current;
    if (date) {
      params.date = date;
    }
    this.setState({
      pageNo: current,
    });
    params.orgUuid = orgUuid || this.orgUuid;
    params.userUuid = userUuid || this.userUuid;
    params.type = type || this.type;
    params.status = status || this.status;
    if (params.status < 0) {
      params.status = '';
    }
    if (params.type < 0) {
      params.type = '';
    }
    if (params.userUuid < 0) {
      params.userUuid = '';
    }
    queryApplyContractList(params).then(res => {
      if (res.statusCode === 200) {
        res.data.map(item => {
          item.type_name = this.findContractType(item.type);
          return item;
        });
        context.setState({
          data: res.data,
          total: res.totalSize,
        });
      }
    });
  };

  findContractType = id => {
    const { list } = this.props;
    const type = list.map(item => {
      if (parseInt(item.value, 10) === parseInt(id, 10)) {
        return item.key;
      }
      return type;
    });
    for (let i = 0; i < list.length; i++) {
      if (parseInt(list[i].value, 10) === parseInt(id, 10)) {
        return list[i].key;
      }
    }
    return type;
  };

  search = condition => {
    const type = parseInt(condition.type, 10) >= 0 ? condition.type : '';
    const status = parseInt(condition.status, 10) >= 0 ? condition.status : '';
    const userUuid = parseInt(condition.userUuid, 10) >= 0 ? condition.userUuid : '';
    this.date = condition.date ? condition.date : '';
    this.orgUuid = condition.orgUuid ? condition.orgUuid : '';
    this.userUuid = userUuid;
    this.status = status;
    this.type = type;
    this.loadDate(
      1,
      15,
      condition.date,
      condition.orgUuid,
      condition.userUuid,
      condition.type,
      condition.status,
    );
  };

  showModal = record => {
    this.record = record;
    this.setState({
      applyModalVisible: true,
    });
  };

  cancel = () => {
    this.setState({
      applyModalVisible: false,
    });
  };

  goBack = () => {
    this.props.router.go(-1);
  };

  columns = () => {
    return [
      {
        title: '申请时间',
        dataIndex: 'cdate',
        key: 'cdate',
        render: text => {
          return <span>{moment.unix(text / 1000).format('YYYY-MM-DD')}</span>;
        },
      },
      {
        title: '申请人部门',
        dataIndex: 'orgName',
        key: 'orgName',
      },
      {
        title: '申请人姓名',
        dataIndex: 'userName',
        key: 'userName',
      },
      {
        title: '合同类型',
        dataIndex: 'type_name',
        key: 'type_name',
      },
      {
        title: '份数',
        dataIndex: 'number',
        key: 'number',
      },
      {
        title: '状态',
        dataIndex: 'status',
        key: 'status',
        render: text => {
          return text === 0 ? <span>未分配</span> : <span>已分配</span>;
        },
      },
      {
        title: '分配时间',
        dataIndex: 'checkTime',
        key: 'checkTime',
        render: text => {
          return <span>{text ? moment.unix(text / 1000).format('YYYY-MM-DD') : ''}</span>;
        },
      },
      {
        title: '分配人',
        dataIndex: 'checkUser',
        key: 'checkUser',
      },
      {
        title: '操作',
        key: 'done',
        render: (rext, record) => (
          <span>
            {record.status === 0 && this.state.permission.allot ? (
              <a className="ant-dropdown-link" onClick={() => this.showModal(record)}>
                分配
              </a>
            ) : (
              ''
            )}
          </span>
        ),
      },
    ];
  };

  render() {
    const { data, total } = this.state;

    const pagination = {
      total,
      pageSize: 15,
      current: this.state.pageNo,
      onChange: current => {
        this.loadDate(current);
      },
      showTotal: showTotal => {
        return `共 ${showTotal} 条`;
      },
    };
    return (
      <div>
        {/**/}
        <div className="fixed-header">
          <Row justify="start" type="flex" style={{ marginBottom: '16px' }}>
            <BackBtn />
          </Row>
          <Row justify="space-between" type="flex" style={{ marginBottom: '16px' }}>
            <SearchForm search={this.search} />
          </Row>
        </div>
        <div style={{ paddingTop: '125px' }}>
          <Table
            rowKey="uuid"
            rowSelection={{}}
            columns={this.columns()}
            dataSource={data}
            pagination={pagination}
          />
        </div>
        {this.state.applyModalVisible ? (
          <ModalAllot cancel={this.cancel} record={this.record} loadDate={this.loadDate} />
        ) : (
          ''
        )}
      </div>
    );
  }
}
export default connect(state => ({
  list: state.contract_type,
  account_info: state.account_info,
}))(Index);



// WEBPACK FOOTER //
// ./src/components/xianxing/contract/PageApplyList.js